// Axios instance configuration
//
// After the cookie-based session port, axios sends the HttpOnly session_id
// cookie automatically via `withCredentials: true`. Bearer tokens are no
// longer pulled from localStorage — the legacy interceptor would have
// returned a stale `auth_token` key that didn't match the store's
// `access_token` key anyway and is no longer maintained.
//
// For new code, prefer `httpClient` from `src/api/http-client.ts` which uses
// fetch and `credentials: 'include'`. This axios instance is kept for
// existing callers and for libraries that prefer axios's interceptor model.
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});
